import { useQuery } from "@apollo/client";

import Table from "@/components/Table";
import Tabs from "@/components/Tabs";
import AppLayout from "@/layouts/AppLayout";
import { ALL_SECTIONS_QUERY } from "./queries";
import { Section } from "@/types";
import usePageTitle from "@/hooks/usePageTitle";
import { getStickyColumnClasses } from "@/lib/styleHelpers";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";

const pattern = "/sections";

export default function SectionManagement() {
  useRequireCapability({ domain: DOMAIN.SECTIONS, permission: PERMISSION.viewPeople });

  usePageTitle(pattern, "Sections");

  const { data, loading } = useQuery<{ sections: Section[] }>(ALL_SECTIONS_QUERY);

  return (
    <AppLayout bottomBar>
      <Tabs
        tabItems={[
          {
            active: true,
            label: "Sections"
          }
        ]}
      />
      <div className="pt-12" />
      <Table
        loading={loading}
        getRowLink={(row) => ({
          to: `/sections/${row.original.id}` as any
        })}
        data={data?.sections || []}
        columns={[
          {
            accessorKey: "name",
            header: "Name",
            enableSorting: false,
            meta: {
              className: getStickyColumnClasses(!!data?.sections.length)
            }
          }
        ]}
      />
    </AppLayout>
  );
}
